import {computed, type ComputedRef} from 'vue';
import {useLocale, useLocalePrefix, useRuntimeConfig} from '#imports';

function toPrismicLang(localeCode: string): string {
    return localeCode.replace('_', '-').toLowerCase();
}

/**
 * Resolves the Prismic `lang` to query for the current host/locale strategy.
 *
 * On multi-locale hosts (www.malt.com) without locale-prefix strategy, Prismic
 * content is served in English. Otherwise the current app locale is used.
 */
export function usePrismicLang(): {lang: ComputedRef<string>} {
    const {locale, isMultiLocaleHost} = useLocale();
    const {getLocalePrefix, getLocaleCodeFromPrefix} = useLocalePrefix();
    const runtimeConfig = useRuntimeConfig();

    const lang = computed(() => {
        if (!isMultiLocaleHost.value) {
            return toPrismicLang(locale.value);
        }

        const enableLocalePrefixStrategy = !!runtimeConfig.public['@malt/nuxt-i18n-module']?.enableLocalePrefixStrategy;
        const localePrefix = getLocalePrefix();
        const localeCode = localePrefix ? getLocaleCodeFromPrefix(localePrefix) : undefined;
        if (enableLocalePrefixStrategy && localeCode) {
            return toPrismicLang(localeCode);
        }
        return 'en';
    });

    return {lang};
}
